function findObjectById(data, id) {

  for (const item of data) {
    if (item.id === id) {
      return item; // 找到目标对象，直接返回
    }
    if (item.child && item.child.length > 0) {
      const found = findObjectById(item.child, id); // 递归查找子节点
      if (found) {
        return found; // 如果在子节点中找到，返回结果
      }
    }
  }
  return null; // 未找到返回 null
}



function groupIdInfo(group_id) {
  const groupList = sessionStorage.getItem('groupList');
  if (!groupList) {
    return null;
  }
  group_id = parseInt(group_id);
  const result = findObjectById(JSON.parse(groupList), group_id);

  return result;
}

export default groupIdInfo;